// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"410":"completeInsurance","703":"admins","781":"insurance","884":"admin"}[chunkId] + "." + {"410":"9e4d0292","703":"9e4d0292","781":"9e4d0292","884":"44f5d4a3"}[chunkId] + ".css";
};